/**
 * Texte der Kontierungsfelder (Plan „Rollen am Geschäftspartner und Lieferantenverträge“, Aufgabe 8; P5): eine Tabelle
 * mit englischen Schlüsseln, kein Text im JSX. Aufgabe 9 hat den Hinweis „anderer Kontenrahmen“ ergänzt.
 */
export const KONTIERUNG_TEXT = {
  account: "Konto",
  costCentre: "Kostenstelle",
  none: "ohne",
  inactive: "deaktiviert",
  deferred: "wird mit dem DATEV-Export der Folgestufe übergeben",
  /** Der Hinweis am Vertrag und am Artikel: Dort wird nichts übergeben, die Kontierung ist eine Vorgabe (A-K6). */
  contractDefault: "Vorgabe für die Eingangsrechnungen dieses Vertrags",
  productDefault: "Vorgabe für Positionen mit diesem Artikel",
  pending: "…",
  /** Ein gesetzter Eintrag, den auch das Nachholen nicht findet bzw. dessen Nachholen scheiterte (Restkorrektur N4). */
  unavailable: "nicht mehr verfügbar",
  notLoaded: "nicht geladen",
  listsFailed: "Konten oder Kostenstellen konnten nicht geladen werden.",
  locked: "Die Rechnung ist an DATEV übergeben; die Kontierung steht fest.",
  otherChart: "anderer Kontenrahmen",
  otherChartHint: "Das Konto gehört nicht zum Kontenrahmen dieses Unternehmens; beim Speichern meldet die Prüfung „anderer Kontenrahmen“.",
  // Lieferanten Strang E (Aufgabe 18): Kontierung je Position im Positionseditor.
  row: (nummer: number) => `Kontierung Zeile ${nummer}`,
  invoiceConfirmTitle: "Kontierung ändern?",
  invoiceConfirmText: (name: string) =>
    `Die Kontierung von „${name}“ wird sofort gespeichert. Beleg und Version der Rechnung bleiben unverändert.`,
  invoiceConfirmButton: "Kontierung speichern",
  invoiceConflict: "Die Position wurde zwischenzeitlich geändert. Die Positionen sind neu geladen — bitte erneut wählen.",
  invoiceFailed: "Die Kontierung konnte nicht gespeichert werden.",
} as const;
